import type React from 'react';

import cn from 'classnames';

import { statusText } from './lib';
import * as st from './styles.module.scss';

export const AvailablePeriodStatus: React.FC = () => {
	return (
		<div className={st.status}>
			<div className={cn(st.status__text, st['confirmed'])}>{statusText['confirmed']}</div>
		</div>
	);
};
